import { APIClient, JavaAPIClient } from "../lib/apiHelper"

const {get, post, put, remove} = new APIClient()
const { get: _get, post: _post, put: _put, remove: _remove } = new JavaAPIClient();

export default {
    /**
     * 근로정보 조회
     * @param {*} companyId 
     * @returns 
     */
    list: (search) => _get(`/workSchedule?${search ? new URLSearchParams(search).toString() : ''}`),
    /**
     * 근로정보 추가
     * @param {*} workSystem 
     * @returns 
     */
    add: (buttonType, recordTypes, workSchedule) => _post(`/workSchedule?buttonType=${buttonType}&recordTypes=${recordTypes.join(',')}`, workSchedule),
    /**
     * 근로정보 수정
     * @param {*} workSystem 
     * @returns 
     */
    modify: workSchedule => _put('/workSchedule', workSchedule),
    /**
     * 근로정보 삭제
     * @param {*} id 
     * @returns 
     */
    delete: id => remove('/workSchedule?id='+id),
    /**
     * 근로정보 조회 - 권한 설정
     * @param {*} companyId
     * @returns
     */
    getScheduleList: (search) => _get(`/workSchedule/byPermission?${search ? new URLSearchParams(search).toString() : ''}`),
    getScheduleList4Flex: (search) => _get(`/workSchedule/byPermission4Flex?${search ? new URLSearchParams(search).toString() : ''}`),
    /**
     * 스케줄 조회 - 엑셀다운로드
     * @param {*} companyId
     * * @param {*} sdate
     * * @param {*} edate
     * @returns
     */
    workScheduleExcelDownload: (search) => _get(`/workSchedule/workScheduleExcelDownload?${search ? new URLSearchParams(search).toString() : ''}`),

    /**
     * 근무일정 - 스케줄 데이터가 있는데 근무데이터가 없는 데이터 조회
     * @param {*} userId
     * * @param {*} companyId
     * * @param {*} sdate
     * * @param {*} edate
     * @returns
     */
    getWorkSchedulesWithoutAttend: (search) => _get(`/workSchedule/without-attend?${search ? new URLSearchParams(search).toString() : ''}`),

	createAttendFromWorkSchedule: (params) => _put('/workSchedule/from-workSchedules', params),
    getTemplateList: (payload) => _post(`/restday/templates-list`,payload),
    createMultiTemplates: (payload) => _post(`/restday/list`, payload),
	getSchedulePatternList: (payload) => _post(`/work-pattern-cycle/list`, payload),
    createSchedulePattern: (payload) => _post(`/work-pattern-cycle`, payload),
    updateSchedulePattern: (payload) => _put(`/work-pattern-cycle`, payload),
    deleteSchedulePattern: (payload) => _remove(`/work-pattern-cycle`, payload),
    createMultiSchedulePattern: (payload) => _post(`/work-pattern-cycle/add-list`, payload),
    getPersonalList: (payload) => _post(`/user-work-pattern-cycle/list`, payload),
    createPersonalAssignment: (payload) => _post(`/user-work-pattern-cycle/assign-list`, payload), 
    updatePersonalAssignment: (payload) => _put(`/user-work-pattern-cycle/assign-list`, payload),     
    deletePersonalAssignment: (payload) => _remove(`/user-work-pattern-cycle`, payload),
    getLeaveAccrualList: (payload) => _post(`/user-al-except/list`, payload),
    merLeaveAccrual: (payload) => _post(`/user-al-except/merge`, payload),
}
